import { PlatformEnvironment } from '@mews/enums';

/** Matches app.mews-$ENV.com or app.mews.com or services.mews.com or cdn.mews.com.... etc...  */
export const ANY_MEWS_URL = new RegExp(/^https?:\/\/[^/?]*\.mews(-[^/?]*)?\.com(?:[/?#]|$)/);

export const CORALOGIX_DOMAIN = 'EU2';

export const DEPLOYMENT_ENVIRONMENT = {
    [PlatformEnvironment.Development]: 'dev',
    [PlatformEnvironment.Demo]: 'demo',
    [PlatformEnvironment.Production]: 'prod',
    [PlatformEnvironment.Test]: 'test',
};

export const CORALOGIX_PUBLIC_KEYS = {
    [PlatformEnvironment.Development]: 'cxtp_JUD4OgoUmrkWi20fCeQAHVqyQaE8uc',
    [PlatformEnvironment.Demo]: 'cxtp_7OipVstMWySJRZ9yn9F7vcJjKGnxei',
    [PlatformEnvironment.Production]: 'cxtp_LSX5IOzXSb9t6Sf9lplGILt4zDG67O',
    [PlatformEnvironment.Test]: 'cxtp_NNQAqRoaWra9ovM9iVFoCQEADtpojC',
};
